import React from 'react';
import {graphql,useStaticQuery} from 'gatsby'
import { Helmet } from 'react-helmet';
const Seo = () => {
    const data = useStaticQuery(graphql`
    query SiteInfo {
        site {
          siteMetadata {
            description
            title
          }
        }
      }
    `)
    return (
        <Helmet>
                <title>{data.site.siteMetadata.title}</title>
                <meta name="description" content={data.site.siteMetadata.description} />
                <link rel="preload" as="image" href="/static/hero_bg.jpg"></link>
                <link rel="icon" type="image/png" sizes="16x16" href="/static/favicon.ico"></link>
        </Helmet>
    );
}

export default Seo;
